export function formatRelativeTime(inputDate: Date): string {
  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - inputDate.getTime();
  const millisecondsInMinute = 60 * 1000;
  const millisecondsInHour = 60 * 60 * 1000;
  const millisecondsInDay = 24 * 60 * 60 * 1000;

  if (timeDifference < 2 * millisecondsInMinute) {
    return 'Just now';
  } else if (timeDifference < millisecondsInHour) {
    const minutes = Math.floor(timeDifference / millisecondsInMinute);
    return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
  } else if (timeDifference < millisecondsInDay) {
    const hours = Math.floor(timeDifference / millisecondsInHour);
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  } else if (timeDifference < 3 * millisecondsInDay) {
    const days = Math.floor(timeDifference / millisecondsInDay);
    return `${days} ${days === 1 ? 'day' : 'days'} ago`;
  } else {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };
    return inputDate.toLocaleDateString(undefined, options);
  }
}
